import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function SEOSettingsModal({ page, onClose, onSave }) {
  const [formData, setFormData] = useState({
    seo_title: page?.seo_title || page?.title || '',
    seo_description: page?.seo_description || '',
    slug: page?.slug || '',
    seo_image: page?.seo_image || '',
    is_indexable: page?.is_indexable !== false
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose} data-testid="seo-settings-modal">
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">SEO Settings - {page?.title}</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Page Title (SEO)</label>
              <input
                type="text"
                className="form-input"
                value={formData.seo_title}
                onChange={(e) => handleChange('seo_title', e.target.value)}
                placeholder="Enter SEO title..."
                data-testid="seo-title-input"
              />
              <small style={{ color: '#888', fontSize: '12px' }}>
                {formData.seo_title.length}/60 characters recommended
              </small>
            </div>
            
            <div className="form-group">
              <label className="form-label">Meta Description</label>
              <textarea
                className="form-textarea"
                value={formData.seo_description}
                onChange={(e) => handleChange('seo_description', e.target.value)}
                placeholder="Enter meta description..."
                rows={3}
                data-testid="seo-description-input"
              />
              <small style={{ color: '#888', fontSize: '12px' }}>
                {formData.seo_description.length}/160 characters recommended
              </small>
            </div>
            
            <div className="form-group">
              <label className="form-label">URL Slug</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#888' }}>yoursite.com/</span>
                <input
                  type="text"
                  className="form-input"
                  value={formData.slug}
                  onChange={(e) => handleChange('slug', e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
                  placeholder="page-slug"
                  style={{ flex: 1 }}
                  data-testid="seo-slug-input"
                />
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label">Social Share Image URL</label>
              <input
                type="url"
                className="form-input"
                value={formData.seo_image}
                onChange={(e) => handleChange('seo_image', e.target.value)}
                placeholder="https://..."
                data-testid="seo-image-input"
              />
              <small style={{ color: '#888', fontSize: '12px' }}>
                Recommended size: 1200x630 pixels
              </small>
            </div>
            
            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={formData.is_indexable}
                  onChange={(e) => handleChange('is_indexable', e.target.checked)}
                  style={{ width: '18px', height: '18px' }}
                  data-testid="seo-indexable-checkbox"
                />
                <span className="form-label" style={{ margin: 0 }}>
                  Allow search engines to index this page
                </span>
              </label>
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="toolbar-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="toolbar-btn primary" data-testid="save-seo-btn">
              Save SEO Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
